import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import Slide from '@material-ui/core/Slide';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

import niaLogo from '../../static/img/logo.webp';

const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  toolbar: {
    minHeight: '80px',
  },
  flowGrow: {
    flexGrow: 1,
  },
  logo: {
    marginLeft: 10,
    height: 70,
    marginTop: '4px',
  },
});

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};


class SimpleNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { classes, elevation } = this.props;
    return (
      <React.Fragment>
        <HideOnScroll {...this.props}>
          <AppBar className={classes.appBar} elevation={elevation} position="fixed">
            <Toolbar className={classes.toolbar}>
              <div className={classes.flowGrow}>
                <Link to="/">
                  <img src={niaLogo} alt="Nia" className={classes.logo} />
                </Link>
              </div>
            </Toolbar>
          </AppBar>
        </HideOnScroll>
      </React.Fragment>
    );
  }
}

SimpleNavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  elevation: PropTypes.number,
};

export default withStyles(styles)(SimpleNavBar);
